import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from 'src/app/service/shared/shared.service';
import { HttpService } from 'src/app/service/http/http.service';
import { GenericService } from 'src/app/services/genericService/generic.service';
import { Config } from 'src/app/app-constant';
import { DwmGenericServiceService } from '../../_DWM-Generic-Services/generic-service.service';
import { GetCompanyAndUsersData } from 'src/app/services/get-company-and-users-data/get-company-and-users-data.service';
import { AllPopupModalExecutionServiceService } from 'src/app/shared/services/all-popup-modal-execution-service.service';

@Component({
  selector: 'app-reassign-tasks',
  templateUrl: './reassign-tasks.component.html',
  styleUrls: ['./reassign-tasks.component.scss']
})
export class ReassignTasksComponent implements OnInit {
  selectedEmpId = null;
  selectedUserData: any = null;
  skipDayEmps = [];
  filteredDwmManagerUser: any = [];

  constructor(
    private matDialogRef: MatDialogRef<ReassignTasksComponent>,
    @Inject(MAT_DIALOG_DATA) public matDialogData: any,
    public dwmGenericServiceService: DwmGenericServiceService,
    public sharedService: SharedService,
    private httpService: HttpService,
    private config: Config,
    public dialog: MatDialog,
    private toastr: ToastrService,
    public genericService: GenericService,
    private getCompanyAndUsersData: GetCompanyAndUsersData,
    private allPopupModalExecutionServiceService: AllPopupModalExecutionServiceService
  ) {}

  ngOnInit() {
    // Get skip day data
    this.httpService.callGetService(`${this.config.getSkipDay}?companyId=${this.getCompanyAndUsersData.loggedInUserCompanyID}`).subscribe({
      next: (data: any) => (this.skipDayEmps = data?.status ? data?.data : [])
    });
    this.filteredDwmManagerUser = this.matDialogData?.dwmManagerUser.filter((user: any) => +user.id != +this.matDialogData?.selectedEmpId);
  }

  checkIfEmpHasSkipDay() {
    this.selectedUserData = this.matDialogData?.dwmManagerUser.find((user: any) => +user.id == this.selectedEmpId);
    const isSkipped = this.skipDayEmps.filter((skipEmp: any) => skipEmp.userId == this.selectedEmpId && new Date(skipEmp.dwmDate).getTime() == new Date(this.matDialogData.selectedDate).getTime() && skipEmp.isSkipped !== false);
    if (isSkipped?.length) {
      this.allPopupModalExecutionServiceService.apiSuccessOrErrorMessage({ msg: `${this.selectedUserData?.firstName} ${this.selectedUserData?.lastName} has a skip day on ${this.matDialogData.selectedDate}. Reassigning tasks to this employee may require adjustment.` });
    }
  }

  reassignTasks() {
    // Exited Team DWM only: nobody chosen (or nobody available), so do not ask for confirmation and do not call the API
    if (this.matDialogData?.exitedMode && !this.selectedEmpId) {
      this.toastr.warning('Please select an employee to reassign the tasks to');
      return;
    }

    // Exited Team DWM: tell the manager exactly how much will move (tasks, dates, date range)
    const rows = this.matDialogData?.resignData || [];
    const dates = rows.map((row: any) => String(row.dwmEventDate).substring(0, 10)).sort();
    const moveText = this.matDialogData?.exitedMode && dates.length ? `${new Set(rows.map((row: any) => row.dwmMasterId)).size} task(s), ${dates.length} date(s), ${dates[0]} to ${dates[dates.length - 1]}` : 'tasks';

    this.allPopupModalExecutionServiceService
      .confirmationPopupComponentExe({ msg: `Are you sure you want to reassign ${moveText} from  ${this.matDialogData.userName} to ${this.selectedUserData?.firstName} ${this.selectedUserData?.lastName} ?` })
      .afterClosed()
      .subscribe((confirmed: any) => {
        if (confirmed) this.reassignTasksApiCall();
      });
  }

  reassignTasksApiCall() {
    const payload = this.matDialogData.resignData.map((data: any) => {
      return {
        id: data.id,
        companyId: data.companyId,
        userId: this.selectedEmpId
      };
    });

    // Exited Team DWM: ask the server to enforce the rules (exited owner, open rows, dated after the last working day)
    const reassignUrl = this.matDialogData?.exitedMode ? `${this.config.updateReassignTasks}?exitedOnly=true` : this.config.updateReassignTasks;

    this.httpService.callPostService(reassignUrl, payload).subscribe({
      next: (response: any) => {
        if (response.status) {
          this.toastr.success(response.message);
          this.matDialogRef.close(true);
        } else {
          this.toastr.error(response.message);
        }
      }
    });
  }
}
